import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rd-select-option',
  template: `<div class="optionValue" (click)="valueSelected.emit(value)">
  <ng-content></ng-content>
</div>
`,
  styles: [`.optionValue{cursor:pointer}`]
})
export class RDSelectOptionComponent implements OnInit {

  @Input() value = '';
  @Input() text = '';

  @Output() valueSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}
